import api from './api';

export const aboutService = {
  get: () => api.get('/about'),
  update: (data) => api.put('/about', data),
};